import styled from 'styled-components';

export const CreateCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  aspect-ratio: 1180 / 1104;
  padding: 24px;
  border-radius: 14px;
  border: 1.5px dashed ${({ theme: { colors } }) => colors.outlineVariant};
  background: transparent;
  color: ${({ theme: { colors } }) => colors.onSurface};
  font: inherit;
  text-align: center;
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease;

  &:hover {
    border-color: ${({ theme: { colors } }) => colors.primary};
    background: ${({ theme: { colors } }) => colors.surfaceContainer};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme: { colors } }) => colors.primary};
    outline-offset: 2px;
  }
`;

export const CreateIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${({ theme: { colors } }) => colors.primaryContainer};
  color: ${({ theme: { colors } }) => colors.onPrimaryContainer};
`;

export const CreateTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

export const CreateHint = styled.span`
  max-width: 240px;
  font-size: 13px;
  line-height: 1.45;
  color: ${({ theme: { colors } }) => colors.onSurfaceVariant};
`;
